import { MA, MASTERCARD } from '../../constants/common-enums';
import fetchReq from '../../helpers/fetch';

const API = {
  /**
   * @param {object} response
   * @param {string} network
   * @param {string} intentId
   * @param {string} baseRequestPayload
   * @param {string} apikey
   * @returns {object} response object
   */
  paymentData: (response, network, intentId, baseRequestPayload, apikey) => {
    const paymentDataUri = '/wallet-services-web/src/payment/data';
    let url = `${paymentDataUri}?apikey=${apikey}`;
    const payloadJWS = response.checkoutResponseSignature
      ? response.checkoutResponseSignature
      : response.checkoutResponseJws;
    const requestPayload = {
      cardBrand: network === MA ? MASTERCARD : network,
      createIntentRequestStr: baseRequestPayload,
      payloadJWS
    };
    if (intentId) {
      requestPayload.intentId = intentId;
      url = `${url}&intentId=${intentId}`;
    }
    const headers = {
      Accept: 'application/json',
      Authorization: 'POP; ct="SRC_EMBEDDED_MESSAGE", mba="payloadJWS"',
      'Content-Type': 'application/json;charset=utf-8'
    };
    const options = {
      body: requestPayload,
      headers,
      method: 'POST',
      url
    };
    return fetchReq(options);
  }
};

export default API;
